const accentReplaceMap: Map<string, string> = new Map([
    ['é', 'e'],
    ['è', 'e'],
    ['ê', 'e'],
    ['ë', 'e'],
    ['à', 'a'],
    ['â', 'a'],
    ['ç', 'c'],
    ['ô', 'o'],
    ['ó', 'o'],
    ['ò', 'o'],
    ['î', 'i'],
    ['í', 'i'],
    ['ï', 'i'],
    ['ñ', 'n'],
    ['û', 'u'],
    ['ú', 'u'],
    ['ù', 'u'],
    ['ü', 'u'],
    ['š', 's']
])

const replaceAccents = (searchString: string): string => {
    return searchString.replace(/[^\w ]/g, (char: string) => {
        return accentReplaceMap.get(char) || char
    })
}

export default replaceAccents
